import { IInvoiceSerializer } from '~/types/invoice';
import { IEstimateSerializer } from '~/types/estimate';
import { IBusiness } from '~/types/business';

export const DEFAULT_BUSINESS: IBusiness = {
  business_uuid: '',
  first_name: '',
  last_name: '',
  company_name: '',
  email: '',
  website: '',
  country_code: '',
  phone: '',
  country: '',
  address_line_1: '',
  address_line_2: '',
  city: '',
  postal_code: '',
  state: '',
  currency: '',
  terms: '',
  notes: '',
  template_id: '',
  logo_url: '',
  discount: '',
  discount_type: 'flat',
  shipping: '',
  shipping_type: 'flat',
  tax: '',
  tax_type: 'flat',
  branding_color: '',
};

export const DEFAULT_INVOICE: IInvoiceSerializer = {
  id: 0,
  archived: false,
  paid_date: '',
  created_on: '',
  pdf_url: '',
  invoice_uuid: '',
  invoice_number: '',
  status: 'Draft',
  payment_status: 'Outstanding',
  payment_due_status: 'On Time',
  logo_url: '',
  invoice_date: '',
  due_date: '',
  po_number: '',
  notes: '',
  terms: '',
  currency: '',
  discount_percentage: 0,
  discount_amount: 0,
  discount_type: 'flat',
  shipping_percentage: 0,
  shipping_amount: 0,
  shipping_type: 'flat',
  tax_percentage: 0,
  tax_amount: 0,
  tax_type: 'flat',
  seller_company_name: '',
  seller_address_line_1: '',
  seller_address_line_2: '',
  seller_city: '',
  seller_state: '',
  seller_postal_code: '',
  seller_country: '',
  seller_email: '',
  seller_phone: '',
  seller_website: '',
  buyer_company_name: '',
  buyer_address_line_1: '',
  buyer_address_line_2: '',
  buyer_city: '',
  buyer_state: '',
  buyer_postal_code: '',
  buyer_country: '',
  buyer_email: '',
  buyer_phone: '',
  buyer_website: '',
  sub_total: 0,
  total_amount: 0,
  total_quantity: 0,
  template_id: '',
  is_shipping_unique: false,
  shipping_company_name: '',
  shipping_address_line_1: '',
  shipping_address_line_2: '',
  shipping_city: '',
  shipping_state: '',
  shipping_postal_code: '',
  shipping_country: '',
  shipping_email: '',
  shipping_phone: '',
  shipping_website: '',
  client_uuid: '',
  items: [],
  is_shipping_enabled: true,
};

export const DEFAULT_ESTIMATE: IEstimateSerializer = {
  id: 0,
  archived: false,
  paid_date: '',
  created_on: '',
  pdf_url: '',
  estimate_uuid: '',
  estimate_number: '',
  status: 'Draft',
  payment_status: 'Outstanding',
  payment_due_status: 'On Time',
  logo_url: '',
  estimate_date: '',
  due_date: '',
  po_number: '',
  notes: '',
  terms: '',
  currency: '',
  discount_percentage: 0,
  discount_amount: 0,
  discount_type: 'flat',
  shipping_percentage: 0,
  shipping_amount: 0,
  shipping_type: 'flat',
  tax_percentage: 0,
  tax_amount: 0,
  tax_type: 'flat',
  seller_company_name: '',
  seller_address_line_1: '',
  seller_address_line_2: '',
  seller_city: '',
  seller_state: '',
  seller_postal_code: '',
  seller_country: '',
  seller_email: '',
  seller_phone: '',
  seller_website: '',
  buyer_company_name: '',
  buyer_address_line_1: '',
  buyer_address_line_2: '',
  buyer_city: '',
  buyer_state: '',
  buyer_postal_code: '',
  buyer_country: '',
  buyer_email: '',
  buyer_phone: '',
  buyer_website: '',
  sub_total: 0,
  total_amount: 0,
  total_quantity: 0,
  template_id: '',
  is_shipping_unique: false,
  shipping_company_name: '',
  shipping_address_line_1: '',
  shipping_address_line_2: '',
  shipping_city: '',
  shipping_state: '',
  shipping_postal_code: '',
  shipping_country: '',
  shipping_email: '',
  shipping_phone: '',
  shipping_website: '',
  client_uuid: '',
  items: [],
  is_shipping_enabled: true,
};
